import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { showToast } from "../utills/tools";
import { ToastContainer, Zoom,toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Import default styles

const Sidebar = ({ sidebarItem, sidebarOpen, closeSidebar }) => {
  const navigate = useNavigate();

  const [openDropdown, setOpenDropdown] = useState(null);
  const location = useLocation(); // Get the current route path

  // Disable scrolling when the sidebar is open on mobile
  useEffect(() => {
    if (sidebarOpen) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
  }, [sidebarOpen]);

  const handleDropdown = (id) => {
    setOpenDropdown(openDropdown === id ? null : id);
  };

  const handelLogout = () => {
    console.log("Logging out...");
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    toast.success("Logout successful!");
    setTimeout(() => {
      navigate("/");
    }, 3000);
  };

  return (
    <div className="relative">
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Zoom} // Correct transition configuration
      />{" "}
      <aside
        id="sidebar-multi-level-sidebar"
        className={`fixed top-10 left-0 z-40 w-64 h-[calc(100vh-2.5rem)] bg-[#02256d] transition-transform ${
          sidebarOpen ? "translate-x-0" : "-translate-x-full"
        } sm:translate-x-0`}
        aria-label="Sidebar"
      >
        <div className="h-full flex flex-col justify-between">
          <div className="px-3 overflow-y-auto">
            <ul className="space-y-1 font-medium">
              {sidebarItem.map((item) => (
                <li key={item.id} className="mt-1">
                  <Link
                    to={`/admin/${item.link}`}
                    onClick={() => {
                      if (item.dropdown) {
                        handleDropdown(item.id);
                      } else {
                        closeSidebar();
                      }
                    }}
                    className={`flex items-center gap-3 px-3 py-2 rounded-lg transition-colors duration-200 ${
                      location.pathname === `/admin/${item.link}` ||
                      location.pathname === item.link
                        ? "text-[#fdbc12]" // Active styles
                        : "text-white hover:text-[#fdbc12] "
                    }`}
                  >
                    <span className="text-base">{item.logo}</span>
                    <span className="text-sm font-medium">{item.name}</span>
                  </Link>
                   {/* Render dropdown if item has dropdown array and is open */}
                   {item.dropdown && openDropdown === item.id && (
                      <ul className="pl-5 space-y-1 mt-2">
                        {item.dropdown.map((subItem) => (
                          <li key={subItem.id}>
                            <Link
                              to={`/admin/${subItem.link}`}
                              className={`flex items-center gap-2 px-2 py-1 rounded-lg transition-colors duration-200 ${
                                location.pathname ===
                                  `/admin/${subItem.link}` ||
                                location.pathname === subItem.link
                                  ? " !text-[#fdbc12]" // Active styles
                                  : "text-white hover:text-[#fdbc12]"
                              }`}
                              onClick={closeSidebar}
                            >
                              <span className="text-base">
                                {subItem.logo}
                              </span>
                              <span className="text-sm font-medium">
                                {subItem.name}
                              </span>
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                </li>
              ))}
            </ul>
          </div>
          <div className="px-3 pb-3">
            <button
              onClick={handelLogout}
              className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-[#fdbc12] text-emerald-950 text-sm font-medium rounded-lg hover:bg-yellow-400 transition-colors duration-200"
            >
              Logout
            </button>
          </div>
        </div>
      </aside>
    </div>
  );
};

export default Sidebar;
